import { makeStyles } from "@material-ui/core";

export const LoginStyle = makeStyles(theme => ({
  formWrapper: {
    padding: 40,
  },
  userTitle: {
    textAlign: "center",
    paddingTop: 30,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: "#f2f2f2",
  },
  lineWrapper: {
    margin: "0 20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
  },
  submitWrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: "20px 0",
  },
  fullHeight: {
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundImage: 'linear-gradient(to bottom right, #213245, #537dac)',
    backgroundColor: "#f2f2f2"
  },
  optimeLogo: {
    position: 'fixed',
    top: 30,
    width: 300,
    height: 'auto',
  },
  BackgroundImageWrapper: {
    position: 'fixed',
    width: '100%',
    bottom: '0',
    height: '500px',
    overflow: 'hidden',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-end',
    // height: '100vh',
    // width: '100vw',
    zIndex: '-1',
  },
  inputWrapper:{
    width: '100%',
    marginBottom: '10px',
  },
  errorHlperText:{
    color: "#f92323",
  },
  TextField: (styleConf) => ({
      width: '100%',
      '& .MuiInputBase-root::before': {
        borderRadius: '0 0 5px 5px',
        color: "#f2f2f2"
      },
      '& .MuiInputBase-input': {
        paddingLeft: '15px',
        fontSize: styleConf.textSize || '1.15rem',
        color: "#f2f2f2"
      },
      '& .MuiInputLabel-filled': {
        color: styleConf.error ? "#f92323" : "#00d4ff",
        fontSize: styleConf.textSize || '1.15rem',
      },
      '& .MuiFilledInput-root': {
        borderRadius: 10,
        fontSize: styleConf.textSize || '1.15rem',
        color: "#f2f2f2"
      },
      '& label.Mui-focused': {
        color: styleConf.error ? "#f92323" : "#f2f2f2",
        fontSize: styleConf.textSize || '1.15rem',
      },
      '& .MuiInput-underline:after': {
        borderBottomColor: styleConf.error ? "#f92323" : "#f2f2f2",
        fontSize: styleConf.textSize || '1.15rem',
      },
      '& .MuiOutlinedInput-root': {
        '& fieldset': {
          borderColor: styleConf.error ? "#f92323" : "#f2f2f2",
          fontSize: styleConf.textSize || '1.15rem',
        },
        '&:hover fieldset': {
          borderColor: styleConf.error ? "#f92323" : "#f2f2f2",
          fontSize: styleConf.textSize || '1.15rem',
        },
        '&.Mui-focused fieldset': {
          borderColor: styleConf.error ? "#f92323" : "#f2f2f2",
          fontSize: styleConf.textSize || '1.15rem',
        },
      },
  })
}));